var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleModalDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_30147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6894 30.2493L68.6893 30.2493L68.6846 30.2542L37.772 62.2746C37.7715 62.2752 37.7709 62.2758 37.7703 62.2763C37.7391 62.3071 37.6699 62.3574 37.5832 62.4012C37.5421 62.4219 37.5066 62.4362 37.4812 62.4443C37.481 62.4444 37.4809 62.4445 37.4807 62.4445C37.4745 62.4339 37.4673 62.4208 37.4593 62.4046L37.4208 62.3269L37.3583 62.2667L24.3177 49.704C23.7084 48.9203 22.4736 48.4838 21.4245 49.3062C20.9239 49.6194 20.6019 50.0983 20.5203 50.6466C20.4375 51.2028 20.6088 51.7809 21.0017 52.2759L21.0234 52.3033L21.0488 52.3274L34.0772 64.7182C34.8105 65.7922 36.0651 66.5 37.4895 66.5H37.6489C38.9042 66.5 40.1564 65.9593 41.0496 64.8881L71.9491 32.8811C71.95 32.8802 71.9509 32.8793 71.9518 32.8784C72.3906 32.4344 72.5415 31.8387 72.4904 31.2973C72.4396 30.7602 72.1849 30.2204 71.7363 29.8813L71.7157 29.8657L71.6936 29.8523C70.6847 29.2422 69.4771 29.4553 68.6894 30.2493Z",
    fill: "#E37617",
    stroke: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 1C22.068 1 1 22.1734 1 48C1 73.8266 22.068 95 48 95C73.932 95 95 73.8266 95 48C95 22.1734 73.932 1 48 1ZM48 90.8259C24.3859 90.8259 5.2069 71.5305 5.2069 48C5.2069 24.4695 24.3859 5.17406 48 5.17406C71.6141 5.17406 90.7931 24.4695 90.7931 48C90.7931 71.5305 71.6141 90.8259 48 90.8259Z",
    fill: "#E37617",
    stroke: "#E37617"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_30147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleModalDone);
export default __webpack_public_path__ + "static/media/SimpleModalDone.9449ab8dc4cc9a64cfac20479ab62526.svg";
export { ForwardRef as ReactComponent };